import { forwardRef, useImperativeHandle, useRef } from 'react';
import { cx } from '@chakra-ui/utils';
import { useTranslation } from 'react-i18next';

import { InputControlProps } from '../../../@types';
import { createLogLocal } from '../../../utils/createLogLocal';

import { InputControl } from './InputControl';

const log = createLogLocal('EmailControl.tsx');

export const EmailControl = forwardRef((props: InputControlProps, ref) => {
  const { t } = useTranslation();
  const inputRef = useRef();

  useImperativeHandle(ref, () => ({
    beforeSubmit() {
      log('EmailControl beforeSubmit does nothing.');
    },
    async validate() {
      await (inputRef.current as any)?.validate();
    },
  }));

  return (
    <InputControl
      ref={inputRef}
      className={cx('card-form-email-input')}
      {...props}
      rules={{
        validate: (val: any) =>
          val.trim() === '' ||
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(val) ||
          t('invalidEmail'),
      }}
    />
  );
});
